import CollectionApi from 'client/api/v2/CollectionApi';
import SubscriptionConstants from 'client/Payments/pricingMatrix/SubscriptionConstants';

const { SubscriptionFields } = SubscriptionConstants;
const { listPrice } = SubscriptionFields;

class AddOnApi extends CollectionApi {
  constructor() {
    super('/api/v2/addons', {
      skip: 0,
      limit: 100,
      sort: listPrice,
    });
  }
}

export default new AddOnApi();
